<script lang="ts" setup>
defineProps<{
  tournament: ManageTournament
}>()

const userStore = useAuthStore()
</script>

<template>
  <div
    v-if="'autoplay' in tournament"
    class="mr-1 flex gap-1 items-center"
  >
    <UiBadge
      v-if="userStore.isPrinterConnected"
      variant="success"
    >
      {{ $t('Print tool online') }}
    </UiBadge>
    <UiBadge
      v-else
      variant="warning"
    >
      {{ $t('Print tool offline') }}
    </UiBadge>
    <UiBadge
      v-if="tournament.autoplay"
      variant="info"
    >
      {{ $t('Autoplay is enabled') }}
    </UiBadge>
    <UiBadge
      v-if="!tournament.autoplay"
      variant="warning"
    >
      {{ $t('Autoplay is disabled') }}
    </UiBadge>
  </div>
</template>

<style>

</style>
